module.exports = __webpack_public_path__ + "static/img/bean_ten.d3ef69e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dial/img/bean_ten.png
// module id = ctlx
// module chunks = 1